import { IntercomUserOptions } from '@faro/study-designer-model';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import axios from 'axios';
import { cacheForeverQueryOptions } from '../react-query';

export function useIntercomUserData(
    options: Pick<UseQueryOptions<IntercomUserOptions>, 'enabled'>
): UseQueryResult<IntercomUserOptions> {
    return useQuery<IntercomUserOptions>({
        ...cacheForeverQueryOptions,
        ...options,
        queryKey: ['intercom-user-data'],
        queryFn: async ({ signal }) => {
            const response = await axios.get('/api/study-designer/intercom/user-options', { signal });
            return response.data;
        },
    });
}
